<div style="height: calc(100vh - 92px - 20px - 40px);">
	<div class="user-list-button-row">

		<span class="user-list-button" title="Create a new user account">
			<p-splitButton label="Create User" icon="fa fa-plus-square-o"
						   [model]="createMenuItems" appendTo="body"></p-splitButton>
		</span>

	</div>

	<p-table #dt [value]="entries" [resizableColumns]="true" 
			 [scrollable]="true" scrollHeight="calc(100vh - 92px - 20px - 48px - 60px - 40px + 6px)">

		<ng-template pTemplate="header">
			<tr>
				<th pResizableColumn pSortableColumn="username">
					Username
					<p-sortIcon field="username"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="firstname">
					First Name
					<p-sortIcon field="firstname"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="lastname">
					Last Name
					<p-sortIcon field="lastname"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="email">
					Email
					<p-sortIcon field="email"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="class">
					Class
					<p-sortIcon field="class"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="type">
					Type
					<p-sortIcon field="type"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="active">
					Active
					<p-sortIcon field="active"></p-sortIcon>
				</th>
				<th class="uv-table-button-column-2">
				</th>
			</tr>

			<tr>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'username', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'firstname', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'lastname', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'email', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'class', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'type', 'contains')"
						   style="width: 100%;">
				</th>
				<th>
					<input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
						   style="width: 100%;">
				</th>
				<th class="uv-table-button-column-2">
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData>
			<tr [pSelectableRow]="rowData">
				<td>
					<span class="uv-table-value">{{rowData.username}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.firstname}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.lastname}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.email}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.class}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.type}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData.active}}</span>
				</td>
				<td class="uv-table-button-column-2">
					<button [disabled]="!isLicenseValid" class="btn btn-primary uv-first-table-button"
							title="Edit this user" (click)="editUser(rowData.tag)">
						<i class="fa fa-edit"></i>
					</button>

					<button [disabled]="!isLicenseValid" class="btn btn-danger uv-table-button"
							title="Delete this user" (click)="deleteUser(rowData.tag)">
						<i class="pi pi-trash"></i>
					</button>
				</td>
			</tr>
		</ng-template>

	</p-table>

	<user-dialog [(visible)]="userDialogVisible" [target]="userDialogTarget" [create]="userDialogCreate"
				 (onOk)="onUserDialogOkClicked($event)" (onCancel)="onUserDialogCancelClicked()">
	</user-dialog>

	<confirmation-dialog message="Are you sure you want to delete this user?"
						 [display]="confirmDeleteDialogVisible"
						 (onYes)="onDeleteConfirmDialogOkClicked()" (onNo)="onDeleteConfirmDialogCancelClicked()">
	</confirmation-dialog>

	<ad-admin-dialog [(display)]="adAdminDialogVisible" messageType="user" [domains]="adAdminDialogDomains" 
					 (onOk)="onAdAdminDialogOkClicked($event)" (onCancel)="onAdAdminDialogCancelClicked()">
	</ad-admin-dialog>

	<google-admin-dialog [(display)]="gwAdminDialogVisible" messageType="user"
		(onOk)="onGwAdminDialogOkClicked()" (onCancel)="onGwAdminDialogCancelClicked()">
	</google-admin-dialog>

	<directory-user-dialog [(visible)]="dirUserDialogVisible" [target]="dirUserDialogTarget" [domains]="dirUserDialogDomains"
						   [create]="dirUserDialogCreate" [userType]="dirUserDialogType"
						   [dirUsers]="dirUserDialogUsers" [allowSearch]="true"
						   (onOk)="onDirUserDialogOkClicked($event)" (onCancel)="onDirUserDialogCancelClicked()">
	</directory-user-dialog>

</div>